// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../src-custom-solutions/streams-schedule/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../src-custom-solutions/streams-schedule/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headline-bookmarks--button{padding:0!important;margin-top:12px}.headline-bookmarks--button span{display:flex;align-items:center;gap:10px}.headline-bookmarks--button span i{color:var(--color-color-1);font-size:16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
